import { render, staticRenderFns } from "./Testimonialp.vue?vue&type=template&id=68545c68&"
import script from "./Testimonialp.vue?vue&type=script&lang=js&"
export * from "./Testimonialp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports